import { TextArea } from 'govwell-ui'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  autoFocus?: boolean
  caption?: React.ReactNode
  field: TanstackField<string, TKey>
  isDisabled?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  maxLength?: number
  maxRows?: number
  minRows?: number
  placeholder?: string
  width?: React.CSSProperties['width']
}
const TextAreaField = <TKey extends string>({
  autoFocus,
  caption,
  field,
  isDisabled,
  isRequired,
  label,
  maxLength,
  maxRows,
  minRows,
  placeholder,
  width,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = field.state.meta.errors.length > 0
  return (
    <TextArea
      caption={caption}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={label}
      maxLength={maxLength}
      maxRows={maxRows}
      minRows={minRows}
      onValueChange={field.setValue}
      placeholder={placeholder}
      value={field.state.value}
      width={width}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
      autoFocus={autoFocus}
      onBlur={field.handleBlur}
    />
  )
}

export default TextAreaField
